import './ListContent.css';

import { IList } from 'components/List/List';
import * as React from 'react';
import * as Markdown from 'react-markdown';
import styled from 'styled-components';

interface IProps {
  item?: IList;
  opacity: boolean;
}

type Props = IProps;

export class ListContent extends React.Component<Props> {
  public render() {
    const { props } = this;
    return (
      <Container opacity={this.props.opacity}>
        <Title>{props.item && props.item.title}</Title>
        <Markdown
          className="list-content-markdown"
          source={props.item && props.item.content}
        />
      </Container>
    );
  }
}

const Title = styled.h3`
  font-size: 25px;
  font-weight: bold;
  margin-top: 0;
`;

const Container = styled.div<{ opacity: boolean }>`
  padding: 15px;
  flex: 1;
  padding-left: 40px;
  padding-top: 70px;
  padding-bottom: 60px;
  max-width: 890px;
  @media (max-width: 1150px) {
    padding-left: 30px;
    width: initial;
  }
  @media (max-width: 900px) {
    padding: 15px;
  }
  opacity: ${p => (p.opacity ? 1 : 0)};
  transition: 0.25s ease all;
`;

export default ListContent;



// WEBPACK FOOTER //
// ./src/components/ListContent/ListContent.tsx